"use strict";
/**
 * This file is used to create the includeComponent function as well as the interfaces each of the
 * fingerprint components must implement.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentPromises = exports.includeComponent = exports.timeoutInstance = exports.components = void 0;
// components include a dictionary of name: function.
exports.components = {};
//In case a promise time-outs, this is what we use as the value in place
exports.timeoutInstance = {
    'timeout': "true"
};
/**
 * includeComponent is the function each component function needs to call in order for the component to be included
 * in the fingerprint.
 * @param {string} name - the name identifier of the component
 * @param {componentFunctionInterface} creationFunction - the function that implements the component
 * @returns
 */
var includeComponent = function (name, creationFunction) {
    exports.components[name] = creationFunction;
};
exports.includeComponent = includeComponent;
/**
 * The function turns the map of component functions to a map of Promises when called
 * @returns {[name: string]: <Promise>componentInterface}
 */
var getComponentPromises = function () {
    return Object.fromEntries(Object.entries(exports.components).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key, value()];
    }));
};
exports.getComponentPromises = getComponentPromises;
//# sourceMappingURL=factory.js.map